import { Groups } from "@mui/icons-material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";

export const CoursesCalendarRideProduceTableSeatsHead: FC = () => {
  const { t } = useTranslation();

  return (
    <th
      className={clsx(
        "cc-ride-produce-col--center",
        "cc-ride-produce-col--icon",
      )}
    >
      <FramerTooltip
        content={t("course.calendar.producePreviewPersonsCountTooltip")}
      >
        <span className="cc-ride-produce-seats-icon">
          <Groups fontSize="small" />
        </span>
      </FramerTooltip>
    </th>
  );
};
